import { render, staticRenderFns } from "./ConvectorCourse.vue?vue&type=template&id=63b044cc&scoped=true&"
import script from "./ConvectorCourse.vue?vue&type=script&lang=js&"
export * from "./ConvectorCourse.vue?vue&type=script&lang=js&"
import style0 from "./ConvectorCourse.vue?vue&type=style&index=0&id=63b044cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b044cc",
  null
  
)

export default component.exports